import styled, {keyframes, css} from 'styled-components';

export const LeftRightFrame = keyframes`
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
`;

export const LoaderDiv = styled.div(
  props => css`
    width: ${props.width || '30rem'};
    height: ${props.height || '0.5rem'};
    position: ${props.position || 'relative'};
    top: ${props.top || '50%'};
    left: ${props.left || '50%'};
    border-radius: 0.4rem;
    background-color: ${props.theme.colors.grey.lighte7};
    overflow-x: hidden;
    transform: translate(-50%, -50%);
    &:before {
      animation: ${LeftRightFrame} 3s infinite;
      background-image: linear-gradient(
        to right,
        transparent,
        ${props.theme.colors.blue.base},
        transparent
      );
      content: '';
      height: 0.5rem;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      top: 0;
    }
    &:after {
      content: '';
      height: 0.5rem;
      left: 0;
      overflow: hidden;
      position: absolute;
      right: 0;
      top: 0;
    }
  `,
);
